import React from "react";
import { FaCalendarAlt, FaFilter } from "react-icons/fa";

const AnalyticsFilterBar = React.memo(
  ({ date, today, isFilterApplied, onStartDateChange, onEndDateChange, onApply }) => {
    return (
      <div className="analytics-filter-section analytics-filter-card mb-4">
        <div className="d-flex flex-wrap align-items-end gap-3">
          <div className="flex-fill analytics-filter-field">
            <label className="form-label fw-semibold">
              <FaCalendarAlt className="me-1" /> Start Date
            </label>
            <input
              type="date"
              className="form-control"
              value={date.start_date}
              max={today}
              onChange={onStartDateChange}
            />
          </div>

          <div className="flex-fill analytics-filter-field">
            <label className="form-label fw-semibold">
              <FaCalendarAlt className="me-1" /> End Date
            </label>
            <input
              type="date"
              className="form-control"
              value={date.end_date}
              max={today}
              onChange={onEndDateChange}
            />
          </div>

          <div className="analytics-filter-actions">
            <button
              className="btn btn-dark"
              onClick={onApply}
              disabled={!date?.start_date || !date.end_date}
            >
              Apply Filter
            </button>
          </div>
        </div>

        {isFilterApplied && (
          <div className="analytics-filter-applied">
            <FaFilter />
            Showing data from {date.start_date || "…"} to{" "}
            {date.end_date || "…"}
          </div>
        )}
      </div>
    );
  }
);

export default AnalyticsFilterBar;
